import { render, staticRenderFns } from "./IntentRelease.vue?vue&type=template&id=2238b458&scoped=true"
import script from "./IntentRelease.vue?vue&type=script&lang=js"
export * from "./IntentRelease.vue?vue&type=script&lang=js"
import style0 from "./IntentRelease.vue?vue&type=style&index=0&id=2238b458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2238b458",
  null
  
)

export default component.exports